import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
	state: {
		IndexObj: {OuterLayer: 0,details: 0},
		menuIndex: 0,
		vtourArr: [], // 全景数组
		activedPanoId: "scene_01",
		panorama: true, // 全景底部显示
		musicState: 1, // 音乐播放状态
		soundState: 1, // 解说播放状态
		indexState: 0, // 是否是第一次进入首页
		timeSwitchFlag:0,
        audioFlag: 1,
        routerIndex: 0,
        routerFlag: false,
        routerSecondIndex: 0,
	},
	mutations: {
        setRouterSecondIndex(state,index){
            state.routerSecondIndex = index;
        },
        setRouterFlag(state,flag){
            state.routerFlag = flag;
        },
        setRouterIndex(state,index){
            state.routerIndex = index;
        },
		setMenuIndex(state,index){ // 设置主菜单index
			state.menuIndex = index;
			// console.log("vuex打印，菜单的index是",state.menuIndex)
		},
		setAudioFlag(state,flag){
			if(flag == 1){
				this.commit('setmusicState',1);
				this.commit('setsoundState',0);
			}else if(flag == 2){
				this.commit('setmusicState',0);
				this.commit('setsoundState',1);
			}else{
				this.commit('setmusicState',0);
				this.commit('setsoundState',0);
			}
		},
		panoramaSwitch(state,flag=4){
			if(flag == 4){
				state.panorama = !state.panorama;
			}else if(flag == '1'){				
				state.panorama = true;
			}
			else if(flag == '0'){
				state.panorama = false;
			}
		},
		activePano(state,activedPanoId){
			state.activedPanoId = activedPanoId;
		},
		vtourArr(state,data){
			state.vtourArr = data;
			// console.log("vuex打印  ",data);
		},
		setIndexState(state,num){ // 进入首页之后修改状态
			state.indexState = num;
		},
		setmusicState(state,num){ // 音乐按钮状态修改
			console.log("背景状态改变了，当前   " + (num?"正在" : "停止") + "   播放");
			state.musicState = num;
		},
		setsoundState(state,num){ // 音乐按钮状态修改
			console.log("解说状态改变了，当前   " + (num?"正在" : "停止") + "   播放");
			state.soundState = num;
		},
		setIndexObj(state,option){ // 改变外层及里层状态
			if(option.OuterLayer != state.IndexObj.OuterLayer){
				state.IndexObj.OuterLayer = option.OuterLayer;
			}
			state.IndexObj.details = option.details;
			// console.log(state.IndexObj);
		},
		setTimeSwitchFlag(state,flag){
			console.log('lxg', flag);
			state.timeSwitchFlag = flag;
			if(flag == 'true'){				
				state.timeSwitchFlag = true;
			}
			else {
				state.timeSwitchFlag = false;
			}
		},
	},
	getters: {
		getmusicState(state, num) { // 音乐按钮状态修改
			console.log("获取到的音乐状态是" + state.musicState);
			return state.musicState;
		},
	},
})
